import { Routes } from '@angular/router';
import { LayoutComponent } from '@shared/layout/layout.component';
import { featureGuard } from '@shared/route-guards/feature.guard';
import { accessGuard } from './pages/auth/guards/access.guard';
import { authGuard } from './pages/auth/guards/auth.guard';
import {hasPermissionGuard} from "@features/auth/has-permission.guard";
import {b2bGuard} from "@shared/route-guards/b2b.guard";
import {PERMISSIONS_CONFIG} from "@features/auth/permissions.config";

export default [
  {
    path: 'auth',
    loadChildren: () => import('./pages/auth/auth.routes'),
    canMatch: [authGuard]
  },
  {
    path: '',
    component: LayoutComponent,
    children: [
      {
        path: 'dashboard',
        loadComponent: () => import('./pages/dashboard/dashboard.component'),
        title: 'Dashboard',
        data: {
          feature: 'home',
          requiredPermissions: PERMISSIONS_CONFIG.dashboard
        },
        canMatch: [featureGuard, hasPermissionGuard]
      },
      {
        path: 'team-members',
        loadComponent: () => import('./pages/team-members/team-members.component'),
        title: 'Team Members',
        data: {
          feature: 'teamMembers',
          requiredSomePermissions: PERMISSIONS_CONFIG.teamMember
        },
        canMatch: [featureGuard, hasPermissionGuard]
      },
      {
        path: 'kyc',
        loadChildren: () => import('./pages/kyc/kyc.routes'),
        data: { feature: 'identityVerification' },
        canMatch: [featureGuard]
      },

      {
        path: 'vouchers',
           loadChildren: () => import('./pages/vouchers/vouchers.routes')
          .then(r => r.routes),

        title: 'Vouchers',
        data: {
          feature: 'vouchers',
          requiredSomePermissions: PERMISSIONS_CONFIG.vouchers
        },
        canMatch: [featureGuard, hasPermissionGuard]
      },
      {
        path: 'balance-history',
        loadComponent: () => import('./pages/balance-history/balance-history.component'),
        title: 'Balance History',
        data: {
          feature: 'balanceHistory',
          requiredSomePermissions: PERMISSIONS_CONFIG.balanceHistory
        },
        canMatch: [featureGuard, hasPermissionGuard]
      },
      {
        path: 'transaction-details/:id/:transactionType',
        loadComponent: () => import('./pages/transaction-details/transaction-details.component'),
        title: 'Transaction Details',
        data: {
          feature: 'transactionDetails',
          requiredSomePermissions: PERMISSIONS_CONFIG.transactionDetails
        },
        canMatch: [featureGuard, hasPermissionGuard]
      },
      {
        path: 'transaction-details/:id/:transactionType/request-details/:requestId',
        loadComponent: () => import('./pages/transaction-details/request-details.component').then(m => m.RequestDetailsComponent),
        title: 'Request Details',
        data: {
          feature: 'transactionDetails',
          requiredSomePermissions: PERMISSIONS_CONFIG.requestDetails
        },
        canMatch: [featureGuard, hasPermissionGuard]
      },
      {
        path: 'crypto-transactions',
        loadComponent: () => import('./pages/crypto-transactions/crypto-transactions.component'),
        title: 'Crypto Transactions',
 /*       data: {
          feature: 'cryptoTransactions',
          requiredSomePermissions: PERMISSIONS_CONFIG.cryptoTransactions
        },
        canMatch: [featureGuard, hasPermissionGuard]*/
      },
      {
        path: 'deposit',
        loadComponent: () => import('./pages/add-money/add-money.component'),
        title: 'Add Money',
        data: { feature: 'deposit' },
        canMatch: [featureGuard]
      },
      {
        path: 'withdraw',
        loadComponent: () => import('./pages/send-money/send-money.component'),
        title: 'Send Money',
        data: { feature: 'withdraw' },
        canMatch: [featureGuard]
      },
      {
        path: 'buy-voucher',
        loadComponent: () => import('./pages/buy-voucher/buy-voucher.component'),
        title: 'Buy Voucher',
        data: {
          feature: 'buyVoucher',
          requiredSomePermissions: PERMISSIONS_CONFIG.buyVoucher
        },
        canMatch: [featureGuard, hasPermissionGuard]
      },
      {
        path: 'redeem-voucher',
        loadComponent: () => import('./pages/redeem-voucher/redeem-voucher.component'),
        title: 'Redeem Voucher',
        data: {
          feature: 'redeemVoucher',
          requiredSomePermissions: PERMISSIONS_CONFIG.redeemVoucher
        },
        canMatch: [featureGuard, hasPermissionGuard]
      },
      {
        path: 'security',
        loadComponent: () => import('./pages/security/security.component'),
        title: 'Security',
        data: { feature: 'security' },
        canMatch: [featureGuard]
      },
      {
        path: 'profile',
        loadComponent: () => import('./pages/profile/profile.component'),
        title: 'Profile',
        data: { feature: 'profile' },
        canMatch: [featureGuard]
      },
      {
        path: 'profile/activity-history',
        loadComponent: () => import('./pages/profile/activity-history/activity-history.component'),
        title: 'Activity History',
        data: { feature: 'activityHistory' },
        canMatch: [featureGuard]
      },
      {
        path: 'merge-voucher',
        loadComponent: () => import('./pages/merge-voucher/merge-voucher.component'),
        title: 'Merge Voucher',
        data: {
          feature: 'mergeVoucher',
          requiredSomePermissions: PERMISSIONS_CONFIG.mergeVoucher
        },
        canMatch: [featureGuard, hasPermissionGuard]
      },
      {
        path: 'split-voucher',
        loadComponent: () => import('./pages/split-voucher/split-voucher.component'),
        title: 'Split Voucher',
        data: {
          feature: 'splitVoucher',
          requiredSomePermissions: PERMISSIONS_CONFIG.splitVoucher
        },
        canMatch: [featureGuard, hasPermissionGuard]
      },
      {
        path: 'new-settlement',
        loadComponent: () => import('./pages/settlement/settlement.component'),
        title: 'New Settlement',
        /*data: {
          feature: 'newSettlement',
          requiredSomePermissions: PERMISSIONS_CONFIG.splitVoucher
        },*/
        // canMatch: [featureGuard, hasPermissionGuard]
      },
      {
        path: 'settlement-history',
        loadChildren: () => import('./pages/settlement-history/settlement.routes')
          .then(r => r.routes),
        title: 'Settlement History',
        /*data: {
          feature: 'newSettlement',
          requiredSomePermissions: PERMISSIONS_CONFIG.splitVoucher
        },*/
        // canMatch: [featureGuard, hasPermissionGuard]
      },
      {
        path: 'manage-whitelist',
        loadChildren: () => import('./pages/whitelist/whitelist.routes').then(r => r.routes),
 /*       data: {
          feature: 'manage-whitelist',
          requiredSomePermissions: PERMISSIONS_CONFIG.whitelist
        },
        canMatch: [hasPermissionGuard]*/
      },

      {
        path: '**', redirectTo: 'dashboard'
      },
    ],
    canMatch: [accessGuard]
  },
] as Routes;
